import { render, staticRenderFns } from "./categ_tree.vue?vue&type=template&id=5f121df5&scoped=true&"
import script from "./categ_tree.vue?vue&type=script&lang=js&"
export * from "./categ_tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f121df5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f121df5')) {
      api.createRecord('5f121df5', component.options)
    } else {
      api.reload('5f121df5', component.options)
    }
    module.hot.accept("./categ_tree.vue?vue&type=template&id=5f121df5&scoped=true&", function () {
      api.rerender('5f121df5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/tabs/categ_tree.vue"
export default component.exports